export default "/fonts/vendor/@fontsource/space-mono/files/space-mono-latin-400-normal.woff2?8f145baa88887280a97ad4f257fe49e6";